module.exports = __webpack_public_path__ + "static/media/close.777b93c6.svg";